import { useCallback } from 'react';

import type { PlanChangePreview } from '~/services/api/subscription/getPlanChangePreview';

import { useNonRevalidatingFetcher } from '../useNonRevalidatingFetcher';

interface ReturnProps {
  isLoading: boolean;
  preview?: PlanChangePreview;
  fetchPreview: (priceId: string) => void;
}

const usePlanChangePreview = (): ReturnProps => {
  const fetcher = useNonRevalidatingFetcher<PlanChangePreview>();

  const fetchPreview = useCallback(
    (priceId: string) => {
      fetcher.load(`/plan_change_preview?price_id=${encodeURIComponent(priceId)}`);
    },
    [fetcher],
  );

  const isLoading = fetcher.state === 'loading';
  const preview = fetcher.data && 'amount_due' in fetcher.data ? fetcher.data : undefined;

  return { isLoading, preview, fetchPreview };
};

export default usePlanChangePreview;
